import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ReportMetaData, ReportsResponse } from './report';
import { map } from 'rxjs/operators';

@Injectable()
export class ReportsService {
  constructor(private http: HttpClient) {}

  getReportMetaData(): Observable<ReportMetaData> {
    return this.http.get<ReportMetaData>(`/reports/meta`);
  }

  getReportOverallMetaData(): Observable<ReportMetaData> {
    return this.http.get<ReportMetaData>(`/reports/overallMeta`);
  }

  downloadAsyncReports(token: string) {
    return this.http
      .get<any>(`/reports/async/token/${token}`, { params: { encoded: 'true' } })
      .subscribe(({ url }) => (window.location.href = url));
  }

  //TODO REMOVE AFTER VERSION 2.164 with com.crazycall.web.report.AsyncReportController
  downloadOldReport(oldToken: string) {
    const id = parseInt(oldToken, 10);
    return this.http.get<any>('/reports/async/token/' + id).subscribe(({ url }) => (window.location.href = url));
  }

  generateReportsAsync(filters): Observable<any> {
    return this.http.post('/reports/async/generate', filters);
  }

  generateReports(filters): Observable<ReportsResponse> {
    return this.http
      .post('/reports', filters, {
        headers: {
          accept: ['application/zip', 'application/x-ms-excel']
        },
        responseType: 'arraybuffer',
        observe: 'response'
      })
      .pipe(map(response => this.handleReportsResponse(response)));
  }

  private handleReportsResponse = response => {
    const blob = response.body ? new Blob([response.body], { type: 'application/zip, application/x-ms-excel' }) : null;
    const fileName = this.getFileNameFromHeader(response.headers.get('content-disposition'));
    const successReportsCount = +response.headers.get('reports-success');
    const failureReportsCount = +response.headers.get('reports-empty');
    return { blob, fileName, successReportsCount, failureReportsCount };
  };

  private getFileNameFromHeader = header => {
    if (!header) {
      return null;
    }

    return header
      .split(';')[1]
      .trim()
      .split('=')[1]
      .replace(/"/g, '');
  };
}
